import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { ref, provide, useSlots, ComputedRef, computed } from "vue";

export type ProvideGroup = ComputedRef<{
  selectedIndex?: number;
  setSelectedIndex: (value: number) => void;
  variant?: Variant;
}>;

interface GroupProps {
  as?: string | object;
  selectedIndex?: number;
  variant?: Variant;
}


type Variant = "default" | "boxed";

export default /*#__PURE__*/_defineComponent({
  __name: 'Group',
  props: {
    as: { default: "div" },
    selectedIndex: { default: 0 },
    variant: { default: "default" }
  },
  setup(__props: any) {

const { as, selectedIndex, variant } = __props as { as: string | object, selectedIndex: number, variant: Variant }

const slots = useSlots();
// eslint-disable-next-line


const active = ref(selectedIndex);
const setActive = (value: number) => {
  active.value = value;
};

provide<ProvideGroup>(
  "group",
  computed(() => {
    return {
      selectedIndex: active.value,
      setSelectedIndex: setActive,
      variant: variant,
    };
  })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(as), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slots).default && _unref(slots).default(), (item, key) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
          index: key,
          key: item
        }, null, 8, ["index"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})